import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames";

import Icon from "./Icon";

const ButtonLink = props => {
    const classes = classNames("button-link", props.className, {
        "button-link--icon": props.icon
    });

    return (
        <a className={classes} href={props.href}>
            <span className="button-link__text">{props.text}</span>
            {props.icon && (
                <span className="button-link__icon">
                    <Icon icon={props.icon} />
                </span>
            )}
        </a>
    );
};

ButtonLink.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.string,
    href: PropTypes.string,
    text: PropTypes.string
};

export default ButtonLink;



// WEBPACK FOOTER //
// ./src/components/ButtonLink.jsx